module.exports = __webpack_public_path__ + "static/media/approved.259b3e88.svg";